module.exports = __webpack_public_path__ + "static/img/fengkong2.d673f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fengkong2.png
// module id = nx7Y
// module chunks = 1